import { connect } from 'react-redux';

import TransferringRequests from './TransferringRequests';
import {
  clearTransferringRequestCreatedUpdated,
  getTransferringRequestsList,
  setTransferringRequestDetails,
  sendExportExcelRequest,
} from './transferringRequestsActions';

const mapStateToProps = state => ({
  transferringRequestsList: state.transferringRequests.transferringRequestsList,
  isLoading: state.transferringRequests.transferringRequestsListLoading,
  reportLoading: state.transferringRequests.reportLoading,
});

const mapDispatchToProps = dispatch => ({
  getTransferringRequestsList: () => dispatch(getTransferringRequestsList()),
  sendExportExcelRequest: (params, type) =>
    dispatch(sendExportExcelRequest(params, type)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TransferringRequests);
